module.exports = __webpack_public_path__ + "img/Info-s-hover.9aa841d2.svg";